export default {
  programming: {
    languages: {
      good: ['TypeScript', 'Go', 'C / C++'],
      ok: ['Rust', 'Python'],
    },
    space: [4],
    list: [
      'Практическое знание языков <b>Go</b>, <b>Rust</b> и <b>C/C++</b> в общем, прикладном, объектно-ориентированном, сетевом и <b>встроенном (embedded)</b> программировании.',
      'Интеграция <b>ИИ</b> с другими слоями приложений. Практическое знание областей <b>машинного обучения</b> и <b>глубокого обучения</b>.',
      'Программирование настольных и веб-приложений с использованием технологии <b>Vue</b> и языка <b>TypeScript</b>.',
      'Управление базами данных - опыт работы с <b>SQLite</b>, <b>MongoDB</b> и <b>MySQL</b>. Основы DevOps, включая <b>Google Cloud</b>.',
      'Умение <b>моделировать физические процессы</b> и проводить <b>компьютерные симуляции</b>, в том числе с использованием <b>МО (ML)</b>.',
      'Знание методов компьютерного материаловедения, таких как <b>Монте-Карло</b>, <b>молекулярная динамика</b> или <b>ТФП (DFT)</b>.',
    ],
  },
  technical: {
    space: [3, 6],
    list: [
      'Знание <b>операционных систем</b> и <b>архитектуры компьютеров</b>. Работа в системах <b>Linux / UNIX</b>, включая знание <b>оболочки (shell)</b>.',
      'Базовые знания <b>телеинформатики</b> в таких областях, как компьютерные сети и безопасность данных.',
      'Практические знания в области <b>телекоммуникаций</b>. Настройка установок и создание интернет-систем.',
      'Работа с компьютерным и измерительным оборудованием. <b>Компьютеризация измерений</b> на языке <b>LabVIEW</b>.',
      'Диагностика и ремонт <b>электронных устройств</b>. Умение читать <b>электронные схемы</b>.',
      'Основы эксплуатации и программирования микроконтроллеров <b>AVR</b> и встроенных систем, в частности <b>Arduino</b>.',
      'Умение создавать и читать <b>технические чертежи</b>, а также создавать 2D и 3D схемы в программе <b>NX</b>.',
      'Опыт применения передовых методов исследования материалов, таких как: <b>XRD, DSC, DTA / TGA, TMA, XAS</b>, а также <b>спектроскопии</b>: абсорбционной, люминесцентной, импедансной или инфракрасной.',
    ],
  },
  science: {
    space: [5],
    list: [
      'Комплексное знание процессов и технологий, используемых в <b>физике и химии передовых материалов</b>.',
      'Опыт работы в <b>физике ионных процессов</b>, в частности, в технологиях <b>обработки и хранения энергии</b>.',
      'Знание современных применений <b>физики полупроводниковых структур</b> и <b>твердотельной электроники</b>.',
      'Практическое знание теории и технологических процессов получения <b>наноструктур</b> и <b>низкоразмерных систем</b>.',
      'Практические знания и решение задач в области <b>лазерной физики</b>, <b>оптоэлектроники и фотоники</b>, а также применения <b>ядерной физики</b>.',
      'Знание элементов высшей <b>математики</b> в <b>инженерных и программных приложениях</b>.',
      'Базовые знания <b>статистики и анализа данных</b> в <b>ROOT</b> и <b>Python</b>. Работа с библиотеками <b>NumPy</b>, <b>Pandas</b> и <b>Matplotlib</b>.',
      'Базовое умение выполнять <b>численные</b> и символьные вычисления в <b>Mathematica</b> и <b>Python</b>.',
    ],
  },
  soft: {
    list: [
      'Легкость в <b>усвоении знаний</b>. Быстрое <b>обучение</b>, <b>гибкость</b> и <b>адаптация</b> к изменениям.',
      'Навыки <b>управления проектами</b> и <b>командной работы</b>. Опыт работы в качестве лидера и члена команды.',
      'Хорошие <b>коммуникативные</b> и организаторские <b>навыки</b>. <b>Открытость в общении</b> с людьми.',
      'Опыт специализированного общения на <b>английском</b> языке, подтвержденный участием в научных конференциях.',
      'Способность к <b>логическому, творческому и критическому мышлению</b>.',
    ],
  },
}
